/* 布局 */
//前台
import Layout from "@views/layout";

const ebookcategoryRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "ebookcategory",
            name: "EBOOKCATEGORY",
            meta: {
                title: "电子期刊分类管理",
                sort: 1,
            },
            component: () => import("@views/business/ebookcategory/index.vue"),
            redirect: {
                name: "EBOOKCATEGORY_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "EBOOKCATEGORY_LIST",
                    meta: {
                        title: "电子期刊分类管理",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/ebookcategory/list.vue"),
                },
                                {
                    path: "add",
                    name: "EBOOKCATEGORY_ADD",
                    meta: {
                        title: "新增电子期刊分类管理",
                        parentPath: '/business/ebookcategory/list',
                        operate: true,
                    },
                    component: () => import("@views/business/ebookcategory/form.vue"),
                },
                                                {
                    path: "edit",
                    name: "EBOOKCATEGORY_EDIT",
                    meta: {
                        title: "编辑电子期刊分类管理",
                        parentPath: '/business/ebookcategory/list',
                        operate: true,
                    },
                    component: () => import("@views/business/ebookcategory/form.vue"),
                },
                                        ],
    },


        ],
};

export default ebookcategoryRouter;
